import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

import { colorFromTheme } from "../../utils/color";
import { inputGlow } from "../../utils/styles";

/** The link that the card takes you to when you click on it */
export const CardLink = styled(Link).attrs({ draggable: false })`
  text-decoration: none;
`;
/** Any alternative actions that need to receive onClick events inside of
 * the card must be wrapped in this component
 */
export const CardAction = styled.div`
  z-index: 1;
  position: relative;
  cursor: initial;
`;

/**
 * A card area that can be selected and copied.
 * This should be used sparingly. It makes the card itself harder to click.
 * It also CANNOT be used to make the CardLink (the purple text) itself
 * clickable, it just doesn't work.
 * */
export const CardSelectable = styled.div`
  z-index: 1;
  position: relative;
  cursor: text;
`;

/** A clickable card area meant to navigate you to a page inside the app */
export const LinkCard = styled.article<{ clickable?: boolean }>`
  border: solid 2px ${colorFromTheme("surface5")};
  border-radius: 0.5rem;
  padding: 1rem;
  transition: border 0.2s;
  ${(props) =>
    props.clickable !== false &&
    css`
      cursor: pointer;
    `};

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  // make the entire section clickable
  position: relative;
  & ${CardLink}::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  // hide the outline of the link itself since the entire box is outlined instead
  & ${CardLink}:focus {
    outline: none;
  }

  // glow when the link is focused
  ${inputGlow}

  &:hover,
  &:focus-within {
    border-width: 2px;
    img {
      opacity: 1;
      filter: grayscale(0);
    }
  }
`;
